import { render } from "./HoverbitPage.vue?vue&type=template&id=d4a71000&scoped=true"
import script from "./HoverbitPage.vue?vue&type=script&lang=js"
export * from "./HoverbitPage.vue?vue&type=script&lang=js"

import "./HoverbitPage.vue?vue&type=style&index=0&id=d4a71000&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4a71000"]])

export default __exports__